import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../main-page.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PipeRingsManagmentComponent } from '../pipe-rings-managment/pipe-rings-managment.component';
import { PipeRingModel } from '../../../../models/parts/pipering.model.';
import { PiperingGroupModel } from '../../../../models/dictionaries/pipering-group.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';

declare var $: any;


@Component({
  selector: 'app-pipe-rings-grid',
  template: `
<!-- Edit Modal -->
<div class="modal" id="addPipeRingModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="templatePipeRing.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Item no:</span>
                                    <input type="text" [(ngModel)]="templatePipeRing.articleId" formControlName="articleId">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Pipe-Ring group:</span>
                                    <select name="piperingGroupSelect" class="selectHeight" [(ngModel)]="templatePipeRing.piperingGroupId" formControlName="piperingGroupId">
                                        <option *ngFor="let piperingGroup of piperingGroupsData | sortByName" [ngValue]="piperingGroup.id">{{piperingGroup.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion Protection:</span>
                                    <select name="corrosionProtectionSelect" class="selectHeight" [(ngModel)]="templatePipeRing.corrosionProtectionId" formControlName="corrosionProtectionId">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionData | sortByName" [ngValue]="corrosionProtection.id">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Pipe ring family:</span>
                                    <select name="corrosionProtectionSelect" class="selectHeight" [(ngModel)]="templatePipeRing.piperingFamilyId" formControlName="piperingFamilyId">
                                        <option *ngFor="let piperingFamily of piperingFamiliesArray" [ngValue]="piperingFamily.id">{{piperingFamily.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPipeRing()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addPipeRingModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let pipeRing of pipeRingsGridData, let row_no = index" (click)="onRowClick(row_no, pipeRing._id)"
        style="cursor:pointer" [class.highlighted]="pipeRing._id === selectedRowId">
        <td class="column-width">{{pipeRing.articleId}}</td>
        <td class="column-width">{{pipeRing.name}}</td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.highlighted{background-color:#534f53!important;color:#fff}.modal-dialog{max-width:500px}`]
})
export class PipeRingsGridComponent implements OnInit {
  @Input() pipeRingsComponent: PipeRingsManagmentComponent;
  isPipeRingHidden = true;
  pipeRingsGridData: PipeRingModel[] = [];
  public selectedRowId;
  templatePipeRing = new PipeRingModel();
  headers: string[] = ['Article no.', 'Name'];
  public formGroup: FormGroup;
  public piperingGroupsData: PiperingGroupModel[] = [];
  public corrosionProtectionData: CorosiveProtectionModel[] = [];
  public piperingFamiliesArray: any[] = [];

  constructor(private mainPageService: MainPageService) {
    mainPageService.loadAllPiperingFamilies().subscribe((res) => {
     this.piperingFamiliesArray =  res;
    });
  }

  public ngOnInit(): void {
    this.loadData();
    // this.mainPageService.mysubject.subscribe((value) => {
    //   this.updatePipeRingInDB(value);
    // });
    this.mainPageService.deletePiperingSubject.subscribe((value) => {
      this.pipeRingsGridData = this.pipeRingsGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadData(): void {
    this.mainPageService.loadAllPiperings().subscribe((response) => {
      this.pipeRingsGridData = response.sort(function (a, b) {
        if (a.articleId < b.articleId) { return -1; };
        if (a.articleId > b.articleId) { return 1; };
        return 0;
      });
    });
    this.mainPageService.loadAllPiperingGroups().subscribe((response) => {
      this.piperingGroupsData = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionData = response;
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeRingHidden = !this.isPipeRingHidden;
  }

  onPipeRingClick(sender) {
    this.pipeRingsComponent.showPipeRing(sender);
  }

  onRowClick(row, id) {
    this.selectedRowId = id;
    this.pipeRingsComponent.showPipeRing(this.pipeRingsGridData[row]);
  }

  updatePipeRingInDB(id) {
    let dataToSend;
    let preparedData;
    for (const item of this.pipeRingsGridData) {
      if (item._id === id) {
        dataToSend = item;
        break;
      }
    }
    for (const item of this.pipeRingsGridData) {
      if (item._id === id) {
        preparedData = item;
        break;
      }
    }
    preparedData.articleNumber = dataToSend.articleNumber;
    preparedData.corrosionProtectionId = dataToSend.corrosionProtectionId;
    preparedData.piperingGroupId = dataToSend.piperingGroupId;
    preparedData.name = dataToSend.name;
    this.mainPageService.updatePiperingInDb(JSON.stringify(preparedData)).subscribe(() => { });
  }

  saveNewPipeRing() {
    this.mainPageService.addNewPiperingIntoDb(JSON.stringify(this.templatePipeRing)).subscribe((response) => {
      this.templatePipeRing._id = response;
      this.pipeRingsGridData.push(this.templatePipeRing);
      this.templatePipeRing = new PipeRingModel();
    });
  }

  public prepareCreate() {
    this.templatePipeRing = new PipeRingModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.templatePipeRing.name, Validators.required),
      articleId: new FormControl(this.templatePipeRing.articleId, Validators.required),
      corrosionProtectionId: new FormControl(this.templatePipeRing.corrosionProtectionId, Validators.required),
      piperingGroupId: new FormControl(this.templatePipeRing.piperingGroupId, Validators.required),
      piperingFamilyId: new FormControl(this.templatePipeRing.piperingFamilyId, Validators.required),
    });
  }
}
